function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Simple class to extend setInterval functionality. e.g. pausing an interval.
 */
var WDHCarouselTimer = /*#__PURE__*/function () {
  function WDHCarouselTimer() {
    _classCallCheck(this, WDHCarouselTimer);

    /**
     * The callback function to be called when timer/interval elapses
     * @private
     * @type {function}
     */
    this.callback = null;
    /**
     * The unique ID set by calling setInterval
     * @private
     * @type {number}
     */

    this.timerID = null;
    /**
     * The time the interval started, used when pausing an interval
     * @private
     * @type {number}
     */

    this.startTime = 0;
    /**
     * the currently set interval timing
     * defaults to 5 seconds.
     * @type {number}
     */

    this.currInterval = 5000;
    /**
     * holds the amount of time left in the interval before it was paused.
     * @type {number}
     */

    this.timeRemaining = 0;
    /**
     * lets us know if the timer is currently paused. Useful for scrolling events.
     * @type {boolean}
     */

    this.isPausedByScroll = false;
    /**
     * lets us know if the timer is currently paused by hover
     * @type {boolean}
     */

    this.isPausedByHover = false;
  }
  /**
   * initializes the timer by setting the callback function
   * @param callback
   */


  _createClass(WDHCarouselTimer, [{
    key: "init",
    value: function init(callback) {
      this.callback = callback;
    }
    /**
     * start the interval timer
     */

  }, {
    key: "startInterval",
    value: function startInterval() {
      var _this = this;

      this.startTime = Date.now();
      this.stopInterval(); // prevent button bounce.  ensures all previous timers are clear before starting a new one.

      this.timerID = window.setInterval(function () {
        _this.startTime = Date.now();

        _this.callback();
      }, this.currInterval);
    }
    /**
     * stops the currently running timer
     */

  }, {
    key: "stopInterval",
    value: function stopInterval() {
      window.clearInterval(this.timerID);
    }
    /**
     * pauses the currently running timer
     */

  }, {
    key: "pauseInterval",
    value: function pauseInterval() {
      var now = Date.now();
      this.timeRemaining = this.currInterval - (now - this.startTime);
      this.stopInterval();
    }
    /**
     * resumes a 'paused' timer by setting a timeout for the amount of time remaining in previous interval then resetting the intervals..
     */

  }, {
    key: "resumeInterval",
    value: function resumeInterval() {
      var _this2 = this;

      this.timerID = window.setTimeout(function () {
        _this2.callback();

        _this2.startInterval();
      }, this.timeRemaining);
    }
    /**
     * sets a new interval timing.
     * @param time
     */

  }, {
    key: "setInterval",
    value: function setInterval(time) {
      this.stopInterval();
      this.currInterval = time;
    }
  }]);

  return WDHCarouselTimer;
}();

export default WDHCarouselTimer;